// Components
import { Company, Pagination } from '@hum/types';
import { atom, useAtom } from 'jotai';
import { Result } from '@hum/common';

export const companiesAtom = atom<
  | {
      companies: Company[];
      pagination: Pagination;
    }
  | undefined
>({
  companies: [],
  pagination: {
    pageCount: 0,
    currentPage: 0,
    results: 0,
    pageSize: 0,
  },
});

export const useCompanies = () => {
  const [companies] = useAtom(companiesAtom);

  return { data: companies, loaded: true } as Result<{
    companies: Company[];
    pagination: Pagination;
  }>;
};
